module.exports = __webpack_public_path__ + "img/operation-empty.e38fc3de.png";